import { render, staticRenderFns } from "./VariationTextSelector.vue?vue&type=template&id=21cd2cac&scoped=true"
import script from "./VariationTextSelector.vue?vue&type=script&lang=js"
export * from "./VariationTextSelector.vue?vue&type=script&lang=js"
import style0 from "./VariationTextSelector.vue?vue&type=style&index=0&id=21cd2cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cd2cac",
  null
  
)

export default component.exports